export const CameraMode = {
  picture: 'picture',
  video: 'video',
} as const;

export type CameraModeEnum = (typeof CameraMode)[keyof typeof CameraMode];
